
import { Component, Vue } from "vue-property-decorator";
import { getAPIAuthorizedHeader, EventBus } from "@/services/common";
import Axios from "axios";
import { API_STORE } from "@/config";
import ScrollPaginationMixin from "@/mixins/Pagination.mixin";
import { mixins } from "vue-class-component";
import Modal from "@/views/modal/Modal.vue";
import { ReportFilter } from "@/models/common";
import Datepicker from "vuejs-datepicker";
import NewPageLoader from "@/views/NewPageLoader.vue";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";

@Component({ components: { Modal, Datepicker, NewPageLoader } })
export default class PaymentRequestReportsComponent extends mixins(
  ScrollPaginationMixin
) {
  public filter: any = new ReportFilter();
  public reportType = "all";
  public datedisablefrom: any = { from: new Date()};
  public datedisableto: any = { to: new Date()};
  public paymentRequests = [];
  public isPaymentRequestReportListEmpty = true;
  public showModal = false;
  public selectedPaymentRequest = null;
  public totalCreditAmount = 0;
  public newPageLoader = true;

  public envr = process.env.VUE_APP_AWS_S3_URL;

  public select(value, type) {
    this.paginationConfig.currentPage = 1;
    this.filter[type] = type === 'fromDate' || type === 'toDate'? new Date(value): value;
    if (type == "fromDate") {
       this.datedisableto.to = new Date(value);
    }
    if (type == "toDate") {
      this.datedisablefrom.from = new Date(value);
    }

    if (type == "reportType") {
      this.reportType = value;
    }
    this.$forceUpdate();
  }

  public onPageChange(page) {
    this.paginationConfig.currentPage = page;
    this.getPaymentRequestList();
  }

  public async getPaymentRequestList() {
    var table = $('.isis').DataTable();
    table.destroy();
    this.newPageLoader = true;
    let obj = {
      filter: this.filter,
      limit: 500,
      page: this.paginationConfig.currentPage,
      userId: this.$userId,
    };
    let response = await Axios.get(API_STORE.PORTAL + "getPaymentRequestList", {
      params: obj,
      headers: getAPIAuthorizedHeader(),
    });
    this.newPageLoader = false;
    if (response) {
      if (
        response.data &&
        response.data.paymentRequests &&
        response.data.paymentRequests.docs
      ) {
        this.paginationConfig.totalPages =
          response.data.paymentRequests.totalPages;
        this.paginationConfig.totalLength =
          response.data.paymentRequests.totalDocs;
        this.paymentRequests = response.data.paymentRequests.docs;
        if (this.paymentRequests.length > 0 && this.counter == 0) {
          this.counter++;
          this.isPaymentRequestReportListEmpty = false;
        }
        //Set datatable
        // if ($(window).width() > 720) {
          setTimeout(() => {
            $(".isis").DataTable({
              order: [[10, "desc"]],
              columnDefs: [{ targets: 10, type: "date" }],
              responsive: true,
              destroy: true,
              retrieve: true,
              autoFill: true,
              colReorder: true,
              scrollX: true,
              dom: "Bfrtip",
              buttons: ["csv"],
              lengthMenu: [10, 25, 50, 100],
            });
          }, 1000);
        // }
      }
      this.totalCreditAmount = response.data.totalCreditAmount;
    }
  }

  public paymentAction(
    actionName,
    subdomain,
    paymentRequestId,
    actionPerformed
  ) {
    if (actionPerformed) {
      this.$snotify.info("Action has been already perfomed well!");
      return;
    }
    this.$dialog
      .confirm(`Are you sure to ${actionName} this payment Request?`, {
        okText: "Yes",
        cancelText: "No",
        reverse: false,
      })
      .then(() => {
        this.selectedPaymentRequest = {
          actionName: actionName,
          subdomain: subdomain,
          paymentRequestId: paymentRequestId,
        };
        if (actionName == "decline") {
          this.showModal = true;
        } else {
          this.updatePaymentRequest();
        }
      })
      .catch(() => {
        this.getPaymentRequestList();
      });
  }

  public async updatePaymentRequest() {
    if (this.selectedPaymentRequest) {
      this.newPageLoader = true;
      let response = await Axios.post(
        API_STORE.PORTAL + "updatePaymentRequest",
        this.selectedPaymentRequest,
        {
          headers: getAPIAuthorizedHeader(),
        }
      );
      this.newPageLoader = false;
      if (response) {
          this.$snotify.success(response.data.message);
          EventBus.$emit("refreshWalletAmount", true);
          this.getPaymentRequestList();
      }
    }
  }
  public getInitialFilter() {
    this.filter = new ReportFilter();
    this.filter.fromDate = new Date();
    this.filter.toDate = new Date();
    this.filter.reportType = this.reportType;
  }

  created() {
    this.getInitialFilter();
    this.getPaymentRequestList();
  }

  mounted() {
    $(document).ready(function () {
      $(document).on("search.dt", function () {
        var snapshot = $(".isis")
          .DataTable()
          .rows({ search: "applied", order: "index" })
          .data()
          .toArray();
        let totalCount = 0;
        snapshot.map((value) => {
          totalCount += value[4] == "Credit" ? parseInt(value[2]) : 0;
        });
        $("#searchCreditAmount").text(totalCount);
      });
    });
  }
}
